import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import {
  RingFindAllRequest,
  RingFindAllResponse,
  RingFindRequest,
  RingFindResponse,
} from '../dto';

export abstract class RingRepository {
  abstract findAllPath(): string;
  abstract findAll(
    payload?: RingFindAllRequest,
  ): Observable<HttpResponse<RingFindAllResponse>>;
  abstract find(payload: RingFindRequest): Observable<HttpResponse<RingFindResponse>>;
}


